import type { Scope } from '../../types';

interface Props {
  scope: Scope;
  size?: 'sm' | 'md';
  preview?: boolean;
}

const SCOPE_META: Record<Scope, { label: string; color: string; bg: string; iconPath: string }> = {
  private: {
    label: 'Private',
    color: 'var(--priv-private)',
    bg: 'rgba(45,0,247,.08)',
    iconPath: 'M5 8V6a3 3 0 016 0v2M3.5 8h9v6.5a1.5 1.5 0 01-1.5 1.5H5a1.5 1.5 0 01-1.5-1.5V8z',
  },
  team: {
    label: 'Team',
    color: 'var(--priv-team)',
    bg: 'rgba(217,119,6,.10)',
    iconPath: 'M8 8.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM3 14c0-2 2.2-3.5 5-3.5s5 1.5 5 3.5',
  },
  company: {
    label: 'Company',
    color: 'var(--priv-company)',
    bg: 'rgba(16,185,129,.10)',
    iconPath: 'M3 14V6.5L8 3l5 3.5V14M5.5 14V9.5h5V14M7 6.5h2',
  },
};

export function VisibilityChip({ scope, size = 'sm', preview = false }: Props) {
  const meta = SCOPE_META[scope] ?? SCOPE_META.private;
  const height = size === 'md' ? 22 : 20;

  return (
    <span
      className="visibility-chip chip"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        height,
        padding: '0 8px',
        borderRadius: 'var(--radius-full)',
        background: meta.bg,
        color: meta.color,
        fontSize: size === 'md' ? 11 : 10.5,
        fontWeight: 600,
        letterSpacing: '0.02em',
        border: preview ? `1px dashed ${meta.color}` : 'none',
        fontFamily: 'var(--font-primary)',
        whiteSpace: 'nowrap',
      }}
    >
      <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke={meta.color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d={meta.iconPath} />
      </svg>
      {meta.label}
      {preview && <span style={{ opacity: 0.7, fontSize: 9, fontWeight: 500 }}>· preview</span>}
    </span>
  );
}
